// Shared base classes for every text-like field (Input, NumberInput,
// PhoneInput, EmailInput, PasswordInput) so they stay visually consistent.
export const borderClassFor = (error?: boolean) =>
  error ? 'border-red-400 focus:border-red-500' : 'border-gray-300 focus:border-[#3F707D]';

export const baseFieldClass = (error?: boolean) =>
  `w-full px-4 border rounded-lg text-sm focus:outline-none placeholder-gray-400 h-11 py-2.5 ${borderClassFor(error)}`;
